import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { IAwardRow, IEvl0112mInquiryCnds, IEvl0112mState, SelectOption } from "../../models/evl/evl0112m_model";

const initialState: IEvl0112mState = {
  rows: [],
  inquiryCnds: {
    awardYear: "all",
    empNm: "",
    deptNm: "all",
    postCd: "all",
    awardCd: "all",
  },
  posClsMap: {},
  posOptions: [],
};

const evl0112mSlice = createSlice({
  name: "evl0112m",
  initialState,
  reducers: {
    setRows(state, action: PayloadAction<IAwardRow[]>) {
      state.rows = action.payload;
    },
    setInquiryCnds(state, action: PayloadAction<Partial<IEvl0112mInquiryCnds>>) {
      state.inquiryCnds = {
        ...state.inquiryCnds,
        ...action.payload,
      };
    },
    setPosClsMap(state, action: PayloadAction<Record<string, string>>) {
      state.posClsMap = action.payload;
    },
    setPosOptions(state, action: PayloadAction<SelectOption[]>) {
      state.posOptions = action.payload;
    },
  },
});

export const Evl0112mAction = evl0112mSlice.actions;
export default evl0112mSlice.reducer;